import { Link, NavLink } from 'react-router-dom';
import BrandMark from '@/components/BrandMark';
import BuiltByFluid from '@/components/BuiltByFluid';

const items = [
  { to: '/app', label: 'Dashboard', icon: '⌂', end: true },
  { to: '/app/transactions', label: 'Transactions', icon: '⇄', end: false },
  { to: '/app/connections', label: 'Connections', icon: '⌬', end: false },
  { to: '/app/settings', label: 'Settings', icon: '⚙', end: false },
];

export default function AppSidebar() {
  return (
    <aside className="hidden lg:flex w-60 shrink-0 flex-col border-r border-ink-700 bg-ink-950 px-4 py-6">
      <Link to="/" className="flex items-center px-2 mb-8">
        <BrandMark variant="sign" size="md" />
      </Link>

      <nav className="flex-1 flex flex-col gap-0.5">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-ink-900 text-ink-50'
                  : 'text-ink-300 hover:bg-ink-900 hover:text-ink-50',
              ].join(' ')
            }
          >
            <span className="font-mono text-ink-400">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="mt-6 border-t border-ink-700 pt-4 px-2">
        <BuiltByFluid size="sm" />
      </div>
    </aside>
  );
}
